import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	
    sessionStorage.getItem("Settlement_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');

   if(sessionStorage.getItem("Settlement_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setSettleNo("{Auto}");
     
      //Clear();
   
   }
   else if(sessionStorage.getItem("Settlement_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("Settlement_EditId"));
   }
   else if(sessionStorage.getItem("Settlement_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("Settlement_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }


 

  async function getChitDet()
  {
    try
    {
  
  if(ChitCodeRef.current.length>0)
  {
      
      let postData = {
        ChitCode :ChitCodeRef.current,
        SettleDate:SettleDateRef.current
    }
   
   const results = await apiService.postCall("settlement/getChitDet",postData);
  
   if (results != "-1") {
  
  
   
    setPaidIns(results.data[0][0][0].Ins);
    setRecWt(results.data[0][0][0].RecWt);
    setRate(results.data[0][0][0].Rate);
    setRecAmount(results.data[0][0][0].RecAmt);
    setBonusAdd(0);
    setIncentiveAdd(0);
    setGiftLess (0);
    setGenLess(0);
    setSettledWt(results.data[0][0][0].RecWt);
    setSettledAmount (results.data[0][0][0].RecAmt);
    setGCode(results.data[0][0][0].GCode);
    setMSNo(results.data[0][0][0].MSNo);
    setSchemeName(results.data[0][0][0].SchemeName);
    setSchType(results.data[0][0][0].SchType);
    setNoOfIns(results.data[0][0][0].NoOfIns);
    setInsAmount (results.data[0][0][0].InsAmount);
    setStartDate(results.data[0][0][0].StartDate);
    setEndDate (results.data[0][0][0].EndDate);
    setCustName(results.data[0][0][0].CustName);
    setMobileNo(results.data[0][0][0].MobileNo);
    
  }
  calc();

  } 
    }
    catch (error) {
      console.log(error);
    }
  }


 function calc()
  {
    let Amount=0;
    if(SchTypeRef.current=="WEIGHT")
      {
        Amount=(val(RecWtRef.current)*val(RateRef.current)).toFixed(0);

      }
    else
    {
      Amount=val(RecAmountRef.current);
    }
    setSettledAmount(val(Amount)+val(BonusAddRef.current)+val(IncentiveAddRef.current)-val(GiftLessRef.current)-val(GenLessRef.current));

  }

  const [EditDisabled, setEditDisabled]=useState(false);
  const [dtEmp, setdtEmp,dtEmpRef]=useStateRef([]);
  const [btndisabled, setDisabled] = useState('disabled');
 
  const [dtCloseMode, setdtCloseMode,dtCloseModeRef]=useStateRef([]);
  const [dtChit, setdtChit,dtChitRef]=useStateRef([]);
 
  
const [SettleNo,setSettleNo,SettleNoRef] = useStateRef('');
const [PaidIns,setPaidIns,PaidInsRef] = useStateRef('');
const [RecWt,setRecWt,RecWtRef] = useStateRef('');
const [Rate,setRate,RateRef]= useStateRef('');
const [RecAmount,setRecAmount,RecAmountRef] = useStateRef('');
const [BonusAdd,setBonusAdd,BonusAddRef] = useStateRef('');
const [IncentiveAdd,setIncentiveAdd,IncentiveAddRef] = useStateRef('');
const [GiftLess,setGiftLess,GiftLessRef]  = useStateRef('');
const [GenLess,setGenLess,GenLessRef] = useStateRef('');
const [CloseMode,setCloseMode,CloseModeRef] = useStateRef('');
const [SettleDate,setSettleDate,SettleDateRef] =  useStateRef((new Date()).toISOString().substring(0,10));
const [SettledWt,setSettledWt,SettledWtRef] = useStateRef('');
const [SettledAmount,setSettledAmount,SettledAmountRef]  = useStateRef('');
const [ChitCode,setChitCode,ChitCodeRef] = useStateRef('');
const [GCode,setGCode,GCodeRef] = useStateRef('');
const [MSNo,setMSNo,MSNoRef] = useStateRef('');
const [SchemeName,setSchemeName,SchemeNameRef] = useStateRef('');
const [SchType,setSchType,SchTypeRef] = useStateRef('');
const [NoOfIns,setNoOfIns,NoOfInsRef] = useStateRef('');
const [InsAmount,setInsAmount,InsAmountRef]  = useStateRef('');
const [StartDate,setStartDate,StartDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
const [EndDate,setEndDate,EndDateRef]  =  useStateRef((new Date()).toISOString().substring(0,10));
const [CustName,setCustName,CustNameRef] = useStateRef('');
const [MobileNo,setMobileNo,MobileNoRef] = useStateRef('');
const [EmpId,setEmpId,EmpIdRef] = useStateRef('');
const [OprName,setOprName,OprNameRef] = useStateRef('');
  
   
  
//Emp Details
   


function getEmpName(id)
{
if(id==1)
{
  var result = dtEmpRef.current.find(obj => {
    return obj.OprCode === EmpIdRef.current
  });
if(result!=undefined)
  setOprName(result.OprName);
else
  setOprName(""); 
}


}


function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function ControlSettings()
{


  if((sessionStorage.getItem("Settlement_Action")=="Edit") || (sessionStorage.getItem("Settlement_Action")=="Delete"))
   {

    setEditDisabled(true);
  

   }

 



}



async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }
    
  const results = await apiService.postCall("settlement/Display",postData);

   if (results != "-1") {
     
	 let HeadData=results.data.Head;
 
      setSettleNo(HeadData[0][0].SettleNo);
      setChitCode(HeadData[0][0].ChitCode);
      setPaidIns(HeadData[0][0].PaidIns);
      setRecWt(HeadData[0][0].RecWt);
      setRate(HeadData[0][0].Rate);
      setRecAmount(HeadData[0][0].RecAmount);
      setBonusAdd(HeadData[0][0].BonusAdd);
      setIncentiveAdd(HeadData[0][0].IncentiveAdd);
      setGiftLess (HeadData[0][0].GiftLess);
      setGenLess(HeadData[0][0].GenLess);
      setCloseMode(HeadData[0][0].CloseMode);
      setSettleDate(HeadData[0][0].SettleDate);
      setSettledWt(HeadData[0][0].SettledWt);
      setSettledAmount (HeadData[0][0].SettledAmount);
      setGCode(HeadData[0][0].GCode);
      setMSNo(HeadData[0][0].MSNo);
      setSchemeName(HeadData[0][0].SchemeName);
      setSchType(HeadData[0][0].SchType);
      setNoOfIns(HeadData[0][0].NoOfIns);
      setInsAmount (HeadData[0][0].InsAmount);
      setStartDate(HeadData[0][0].StartDate);
      setEndDate (HeadData[0][0].EndDate);
      setCustName(HeadData[0][0].CustName);
      setMobileNo(HeadData[0][0].MobileNo);
      setEmpId(HeadData[0][0].EmpId);
      setOprName(HeadData[0][0].OprName);

     getLookup();
   }    
   }

    
    
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
     

		let postData = {
			"Action" : sessionStorage.getItem("Settlement_Action"),
			"EditId" : sessionStorage.getItem("Settlement_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "ChitCode": ChitCodeRef.current,
      "PaidIns": PaidInsRef.current,
      "RecWt":RecWtRef.current,
      "RecAmount":RecAmountRef.current,
      "BonusAdd":BonusAddRef.current,
      "IncentiveAdd":IncentiveAddRef.current,
      "GiftLess": GiftLessRef.current,
      "GenLess": GenLessRef.current,
      "CloseMode":CloseModeRef.current,
      "SettleDate":SettleDateRef.current,
      "SettledWt":SettledWtRef.current,
      "SettledAmount":SettledAmountRef.current,
      "Rate":RateRef.current,
      "EmpId":EmpIdRef.current,
     
     	}

    let ErrMsg="";


    if(postData.BillName=="")
    {
    postData.BillName=CustNameRef.current;
    }

    
    if((OprNameRef.current==undefined)||(OprNameRef.current==''))
      {
        ErrMsg="Invalid Employee Code";
      }
  
  

    if((postData.EmpId==undefined)||(postData.EmpId==''))
    {
      ErrMsg="Please Enter Employee Code";
    }


   
  
      if((postData.CloseMode==undefined)||(postData.CloseMode==''))
        {
          ErrMsg="Please Select Close Mode";
        }
      
        if((postData.ChitCode==undefined)||(postData.ChitCode==''))
          {
            ErrMsg="Please Select Chit Code";
          }

          if((postData.SettledAmount==undefined)||(postData.SettledAmount=='')||(val(postData.SettledAmount)==0))
            {
              ErrMsg="Settled Amount is Zero";
            }
 

    if(ErrMsg=="")
    {
    


      const results1 = await apiService.postCall("settlement/ValidationChk",postData);

      if (results1 != "-1") {
   
   if(results1.errorCode=="8888")
   {
       
     
     swal({
   
       title: "",
       text: results1.data,
       icon: "error",
       button: "Ok"
       
     }).then(function () {
       
     });
   
     return;
   
   }  
   
      }



   const results = await apiService.postCall("settlement/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("Settlement_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("Settlement_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("Settlement_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }



  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0,
      "eBranchCode":sessionStorage.getItem("BranchCode")
    };
		
    const results = await apiService.postCall("settlement/Lookup",postData);

  
	 if (results != "-1") {

    setdtChit(results.data[0][0]);
    setdtEmp(results.data[1][0]);
    setdtCloseMode(results.data[2][0]);
    


      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/chit/settlement/list');
  };


  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

          
                <div className='row'>
                  <div className='col-lg-6'>
                       
                        <div className='row py-2'>
                         {(EditDisabled==false) ? (
                        <div className='col-md-4'>
                              <Form.Label>Chit Code</Form.Label>
                              <Select className="form-select-search" 
options={dtChit}
value={dtChit.filter(function(option) {
return option.value === ChitCode;
})}
onChange=
{
(e) => {
setChitCode(e.value);
getChitDet();
}
}
disabled={EditDisabled}>
</Select>

</div>) : (
   <div className='col-md-4'>

   <Form.Label>Group Code</Form.Label>
   <Form.Control type="text" id="txtGCode" className="txtReadOnly" value={ChitCode}  placeholder=""   />
 </div>
)}

                        <div className='col-md-4'>

                            <Form.Label>Group Code</Form.Label>
                            <Form.Control type="text" id="txtGCode" className="txtReadOnly" value={GCode}  placeholder=""   />
                          </div>
                          <div className='col-md-4'>
                            <Form.Label>MS No</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" Readonly="Readonly" value={MSNo} placeholder=""   />
                          </div>

                            <div className='col-md-4'>
                              <Form.Label>Chit Type</Form.Label>
                              <Form.Control type="text" className="txtReadOnly" Readonly="Readonly" value={SchType} placeholder=""   />
                
</div>   

                          <div className='col-md-4'>
                            <Form.Label>Installment Amount</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={InsAmount} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>No.Of Installment</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={NoOfIns} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control type="date"  Readonly="Readonly"  value={StartDate} 
                                   id="txtStartDate" placeholder=""   />
                          </div>

						  
                        <div className='col-md-4'>
                            <Form.Label>End Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly"  value={EndDate}  id="txtEndDate" placeholder=""   />
                          </div>
                          
                          <div className='col-md-4'>
                            <Form.Label>Rate</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" className="txtReadOnly"  value={Rate}   placeholder=""   />
                          </div>
                          
                          
                          <div className='col-md-12'>
                            <Form.Label>Scheme Name</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={SchemeName} ReadOnly="Readonly" placeholder=""   />
                          </div>


                          <div className='col-md-12'>
                            <Form.Label>Customer Name</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={CustName} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-12'>
                            <Form.Label>Mobile No</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={MobileNo} ReadOnly="Readonly" placeholder=""   />
                          </div>
                          

</div>
</div>


                  
                 


                  
                  <div className='col-lg-6'>
                       
                        <div className='row py-2'>
                        <div className='col-md-4'>
                            <Form.Label>Paid Installment</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={PaidIns} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Weight</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={RecWt} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" className="txtReadOnly" value={RecAmount} ReadOnly="Readonly" placeholder=""   />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Bonus (+)</Form.Label>
                            <Form.Control type="text" value={BonusAdd} onChange=
                                  {
                                  (e) => {
                                  setBonusAdd(e.target.value);
                                  calc();
                                  }
                                  }  placeholder=""   />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Incentive (+)</Form.Label>
                            <Form.Control type="text" value={IncentiveAdd} onChange=
                                  {
                                  (e) => {
                                  setIncentiveAdd(e.target.value);
                                  calc();
                                  }
                                  }  placeholder=""   />
                          </div>


                          <div className='col-md-6'>
                            <Form.Label>Gift (-)</Form.Label>
                            <Form.Control type="text" value={GiftLess} onChange=
                                  {
                                  (e) => {
                                  setGiftLess(e.target.value);
                                  calc();
                                  }
                                  }  placeholder=""   />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>General (-)</Form.Label>
                            <Form.Control type="text" value={GenLess} onChange=
                                  {
                                  (e) => {
                                  setGenLess(e.target.value);
                                  calc();
                                  }
                                  }  placeholder=""   />
                          </div>


                          <div className='col-md-6'>
                            <Form.Label>Settled Weight</Form.Label>
                            <Form.Control className="txtReadOnly" ReadOnly="ReadOnly" type="text" value={SettledWt}   placeholder=""   />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Settled Amount</Form.Label>
                            <Form.Control  className="txtReadOnly" ReadOnly="ReadOnly" type="text" value={SettledAmount}   placeholder=""   />
                          </div>


                          <div className='col-md-4'>
                            <Form.Label>Settle No</Form.Label>
                            <Form.Control  className="txtReadOnly" ReadOnly="ReadOnly" type="text" value={SettleNo}   placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Settled Date</Form.Label>
                            <Form.Control type="date"  onChange={(e)=>setSettleDate(e.target.value)} value={SettleDate} 
                                   id="txtStartDate" placeholder=""   />
                          </div>

                          <div className='col-md-4'>
                              <Form.Label>Close Mode</Form.Label>
                              <Select className="form-select-search" 
options={dtCloseMode}
value={dtCloseMode.filter(function(option) {
return option.value === CloseMode;
})}
onChange=
{
(e) => {
setCloseMode(e.value);
}
}
disabled={EditDisabled}>
</Select>

</div>

</div>
</div>
</div>
                  <div className='row'>
                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>

                       
 
 
      <div className='row'>

      <div className='col-lg-2'>
      <div className='col-md-12'>
  <Form.Label>Emp Id</Form.Label>
  <Form.Control type="text" value={EmpId} onChange=
                            {
                              (e) => {
                            setEmpId(e.target.value);
                            getEmpName(1);
                              }
                              } placeholder=""   />
</div>



</div>

<div className='col-lg-4'>
      <div className='col-md-12'>
  <Form.Label>Emp Name</Form.Label>
  <Form.Control type="text"  placeholder="" value={OprName}  className="txtReadOnly" Readonly="ReadOnly"  />
</div>



</div>
        </div>
    

                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
             
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
